import { FaGithub } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
	isAuthOAuthEnabled,
	isAuthOAuthGitHubEnabled,
	isAuthOAuthGoogleEnabled,
} from "@/lib/modules";
import { cn } from "@/lib/utils";
import type { LastSignInMethod } from "@/utils/local-storage";

type AuthOauthSectionProps = {
	lastSignInMethod: LastSignInMethod | null;
	onGoogle: () => void;
	onGithub: () => void;
};

export function AuthOauthSection({
	lastSignInMethod,
	onGoogle,
	onGithub,
}: AuthOauthSectionProps) {
	const showGoogle = isAuthOAuthGoogleEnabled();
	const showGithub = isAuthOAuthGitHubEnabled();

	if (!isAuthOAuthEnabled() || (!showGoogle && !showGithub)) {
		return null;
	}

	const googleIsLastUsed = lastSignInMethod === "google";
	const githubIsLastUsed = lastSignInMethod === "github";
	const twoCols = showGoogle && showGithub;

	return (
		<div className="mt-8">
			<div className="flex items-center gap-3">
				<div className="h-px flex-1 bg-border/80" aria-hidden />
				<span className="shrink-0 text-sm text-muted-foreground">
					or continue with
				</span>
				<div className="h-px flex-1 bg-border/80" aria-hidden />
			</div>
			<div
				className={cn(
					"mt-6 grid grid-cols-1 gap-3 sm:gap-4",
					twoCols && "sm:grid-cols-2",
				)}
			>
				{showGoogle ? (
					<Button
						type="button"
						variant="outline"
						className={cn(
							"h-11 w-full justify-start gap-2 font-medium",
							googleIsLastUsed && "border-primary/40 bg-muted/40",
						)}
						onClick={onGoogle}
					>
						<FcGoogle className="size-5 shrink-0" aria-hidden />
						<span className="min-w-0 flex-1 text-left">Google</span>
						{googleIsLastUsed ? (
							<Badge
								variant="secondary"
								className="shrink-0 px-1.5 py-0 text-[0.65rem] font-medium uppercase tracking-wide"
							>
								Last used
							</Badge>
						) : null}
					</Button>
				) : null}
				{showGithub ? (
					<Button
						type="button"
						variant="outline"
						className={cn(
							"h-11 w-full justify-start gap-2 font-medium",
							githubIsLastUsed && "border-primary/40 bg-muted/40",
						)}
						onClick={onGithub}
					>
						<FaGithub className="size-5 shrink-0" aria-hidden />
						<span className="min-w-0 flex-1 text-left">GitHub</span>
						{githubIsLastUsed ? (
							<Badge
								variant="secondary"
								className="shrink-0 px-1.5 py-0 text-[0.65rem] font-medium uppercase tracking-wide"
							>
								Last used
							</Badge>
						) : null}
					</Button>
				) : null}
			</div>
		</div>
	);
}
